import script from "./favorite-tickets-slider.vue?vue&type=script&setup=true&lang=ts"
export * from "./favorite-tickets-slider.vue?vue&type=script&setup=true&lang=ts"

import "./favorite-tickets-slider.vue?vue&type=style&index=0&id=1c63f69a&lang=css"

const __exports__ = script;

export default __exports__